
export const REQUEST_PROJECTSETUPDATA= 'REQUEST_PROJECTSETUPDATA';
export const PROJECTSETUPDATA_RECEIVED = 'PROJECTSETUPDATA_RECEIVED';
export const REQUEST_UPDATE_TASK_STATUS= 'REQUEST_UPDATE_TASK_STATUS';